import React, { useState } from "react";
import { post } from "../../lib/Fetching";
import Button from "../Button";

export default function PrintAliquotBarcodesButton({ sample_ids, disabled }) {
  const selectedLabel = "Print Selected Aliquots";
  const [highlighted, setHighlighted] = useState(false);
  const [text, setText] = useState(selectedLabel);

  const printSamples = () => {
    const aliquot_ids = window.aliquot_ids || [];
    if (aliquot_ids.length == 0) {
      alert("No aliquots were selected");
      return;
    }
    post("/printing/api/print_aliquots", {
      aliquot_ids
    }).then(json => {
      if (json.errors) {
        alert(json.errors);
      } else {
        setHighlighted(true);
        setText("Printed!!");
        setTimeout(() => {
          setHighlighted(false);
          setText(selectedLabel);
        }, 2000);
      }
    });
  };

  return (
    <Button
      primary
      icon="fa-print"
      title={text}
      highlight={highlighted}
      disabled={disabled}
      onClick={printSamples}
    />
  );
}
